// @flow

import { useQuery, } from 'react-apollo';
import { BREADCRUMBS_QUERY, } from '@haaretz/graphql';

import { useRouter, } from 'next/router';
import useArticleId from './useArticleId';
import usePreview from './usePreview';
import useTagId from './useTagId';
import useAuthorId from './useAuthorId';

export default function useBreadcrumbsData() {
  const articleId = useArticleId();
  const tagId = useTagId();
  const authorId = useAuthorId();
  const { previewId, } = usePreview();
  const router = useRouter();
  const path = router.query.path;

  const id = articleId || authorId || tagId || previewId;

  const { data, loading, error, } = useQuery(BREADCRUMBS_QUERY, {
    fetchPolicy: 'cache-first',
    variables: { model: id ? {
      id,
    } : { path, },
    },
  });

  if (loading) return null;
  if (error) {
    console.error('Breadcrumbs error', error);
    return null;
  }

  if (!data) return null;

  const breadcrumbs = data?.Page?.lineage;

  if (Array.isArray(breadcrumbs)) {
    return [ ...breadcrumbs, ];
  }

  return null;
}
